
import { Component, OnInit, Input } from '@angular/core';
import { AppConstants as AppConstantsBase } from '@aston/foundation';
import { TranslateModule } from '@ngx-translate/core';

import { IFileUploadConfig } from '../../models';

@Component({
	selector: 'file-upload-instructions',
	templateUrl: './file-upload-instructions.component.html',
	imports: [TranslateModule]
})
export class FileUploadInstructionsComponent implements OnInit {
	@Input() config: IFileUploadConfig;

	acceptedExtensions = '';
	maxResolution: { width: number; height: number };
	maxSize: { size: number; unit: string };

	ngOnInit() {
		this.acceptedExtensions = this.config.acceptExtensions.join(', ');
		this.maxResolution = this.config.maxResolution;
		this.maxSize = {
			size: this.config.maxSize / (this.config.maxSize >= AppConstantsBase.MEGABYTE ? AppConstantsBase.MEGABYTE : AppConstantsBase.KILOBYTE),
			unit : (this.config.maxSize >= AppConstantsBase.MEGABYTE ? "Megabyte" : "Kilobyte")
		}
	}

}
